import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import HandshakeIcon from 'mdi-react/HandshakeIcon';
import BankIcon from 'mdi-react/BankIcon';
import { formatUnread } from '../../../shared/functions/unreadPoller';

const SidebarLink = ({
  title, icon, newLink, route, onClick, location, count,
}) => {
  // Normalize away any trailing slash so favorites links like
  // "/investors-db/?page=1&filters=3" (pathname "/investors-db/") still
  // highlight the "/investors-db" menu item.
  const path = location.pathname.replace(/\/+$/, '') || '/';

  // Define active status based on the route and matching logic
  let isActive = false;

  if (route === '/investors-db') {
    isActive = path === '/investors-db' || path.startsWith('/investor-db/');
  } else if (route === '/investors') {
    isActive = path === '/investors' || path.startsWith('/investor/');
  } else if (route === '/founders') {
    isActive = path.startsWith('/founder');
  } else if (route === '/campaigns') {
    isActive = path === '/campaigns'
      || path.startsWith('/campaigns/edit/')
      || path === '/campaigns/create';
  } else {
    isActive = path === route.replace(/\/+$/, '');
  }

  const renderIcon = (i) => {
    const customIcons = {
      handshake: <HandshakeIcon />,
      bank: <BankIcon />,
    };

    return customIcons[i] || <span className={`lnr lnr-${i}`} />;
  };

  return (
    <NavLink
      to={route}
      onClick={onClick}
      className={isActive ? 'sidebar__link-active' : ''}
    >
      <li className="sidebar__link">
        {icon && <span className="sidebar__link-icon">{renderIcon(icon)}</span>}
        <p className="sidebar__link-title">
          {title}
          {newLink ? <span className="sidebar__link-badge">Free</span> : ''}
        </p>
        {count > 0 ? <span className="sidebar__link-count">{formatUnread(count)}</span> : ''}
      </li>
    </NavLink>
  );
};

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
  // Unread counter shown at the right edge of the link (0 hides it).
  count: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};

SidebarLink.defaultProps = {
  icon: '',
  newLink: false,
  route: '/',
  onClick: () => {},
  count: 0,
};

// Export with withRouter to access location
export default withRouter(SidebarLink);
